import { render, staticRenderFns } from "./deactivate-activation.vue?vue&type=template&id=74f93e72&"
import script from "./deactivate-activation.vue?vue&type=script&lang=ts&"
export * from "./deactivate-activation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports